import _ from 'underscore';

export const getLocationName = ({ location, isRadiusTarget, instrumentationService }) => {
  if (!_.isEmpty(location.ExpandedName)) {
    return location.ExpandedName;
  } else if (!_.isEmpty(location.EnglishName)) {
    return location.EnglishName;
  } else if (!_.isEmpty(location.Name)) {
    return location.Name;
  } else if (isRadiusTarget) {
    return `${location.GeoPoint.Latitude}, ${location.GeoPoint.Longitude}`;
  }
  instrumentationService.logError(`Could not get location name: ${JSON.stringify(location)}`);
  return '';
};
